// Shared activity clock for IdleTimer, Auth.js (reload check), and login.actions.js.
export const LAST_ACTIVITY_TIME_KEY = 'lastTime-activity';
